import { render, staticRenderFns } from "./PaymentMethodDetail.vue?vue&type=template&id=fa42ee76&scoped=true&"
import script from "./PaymentMethodDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa42ee76",
  null
  
)

export default component.exports